/* it7 Saved Designers (ITA2-914)
   "Heart" a designer the same way a product is wishlisted, so marketing can alert
   the shopper on that designer's new arrivals / markdowns (historically the
   strongest-performing email trigger — stronger than product wishlists).

   Storage: localStorage `it7desg` = JSON array of ENTRIES [{n, h}, …]
     n — DISPLAY name, kept verbatim so the same string can be shown back in email
     h — brand COLLECTION HANDLE ("prada-women") when the save came from a brand PLP,
         null when it came from a PDP (product.vendor has no single collection there).
   All *matching* goes through norm() so "Chloé" / "Chloe" / "chloÃ©" / "CHLOE" are
   one designer (same folding rule as snippets/it7-normalize-brand.liquid).

   Storage v1 was a bare array of name strings (["Prada","Chloé"]). read() folds v1
   entries into {n, h:null} on the fly and migrate() writes the upgrade back once, so
   no saved designer is ever lost. Reader: the Saved Designers band in
   templates/page.swym.liquid, via the window.IT7DESG API at the bottom of this file.

   Sources of the name (they must agree or the heart won't sync across pages):
     - brand PLP  → collection title with the gender word stripped ("Prada Women" → "Prada"),
                    already computed as brand_name in sections/it7-plp-header.liquid
     - PDP        → product.vendor
   Both are rendered by snippets/it7-designer-save.liquid into data-it7-desg; the brand
   PLP additionally passes its collection handle as data-it7-handle.

   Klaviyo: fires 'Saved Designer' {designer} on SAVE only (never on unsave), via the
   same window._learnq array pattern snippets/klaviyo-events.liquid uses. No new flows.
   Loaded site-wide (defer) from sections/it7-header.liquid, next to it7-wishlist.js. */
(function () {
  var KEY = 'it7desg';
  var EMAIL_KEY = 'it7wlemail';   /* guest email captured elsewhere (waitlist / newsletter) */

  /* read() always hands back v2 entries; `changed` means the stored shape was older or
     dirty and is worth rewriting — done once at load by migrate(), never mid-flight. */
  function read() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return { list: [], changed: false }; }
    if (!Array.isArray(raw)) return { list: [], changed: false };
    var list = [], changed = false;
    for (var i = 0; i < raw.length; i++) {
      var e = raw[i];
      if (typeof e === 'string') {
        if (e.trim()) list.push({ n: e, h: null });       /* v1 string → v2 object */
        changed = true;
      } else if (e && typeof e === 'object' && typeof e.n === 'string' && e.n.trim()) {
        if (typeof e.h === 'undefined') changed = true;
        list.push({ n: e.n, h: (typeof e.h === 'string' && e.h) ? e.h : null });
      } else {
        changed = true;                                   /* junk entry → dropped */
      }
    }
    return { list: list, changed: changed };
  }
  function lsGet() { return read().list; }
  function lsSet(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function migrate() { var r = read(); if (r.changed) lsSet(r.list); }

  /* lowercase + strip accents, and fold the 'Ã©' mojibake the catalogue still carries
     (downcase alone does NOT fold é≠è≠e — see it7-normalize-brand.liquid). */
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase().trim().replace(/ã©/g, 'e');
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s;
  }
  function indexOfName(list, name) {
    var n = norm(name);
    for (var i = 0; i < list.length; i++) { if (norm(list[i].n) === n) return i; }
    return -1;
  }

  /* A designer first hearted from a PDP is stored with h:null — there is no collection
     in scope there. The moment that shopper lands on the same designer's brand PLP we
     adopt the handle, which is what gives the Saved Designers band a piece count and a
     real collection link instead of the /search fallback. Only ever fills a blank. */
  function adopt(saved) {
    var btns = document.querySelectorAll('[data-it7-desg][data-it7-handle]');
    var dirty = false;
    Array.prototype.forEach.call(btns, function (b) {
      var h = (b.getAttribute('data-it7-handle') || '').trim();
      if (!h) return;
      var i = indexOfName(saved, b.getAttribute('data-it7-desg'));
      if (i > -1 && !saved[i].h) { saved[i].h = h; dirty = true; }
    });
    if (dirty) lsSet(saved);
  }

  function paint() {
    var saved = lsGet();
    var btns = document.querySelectorAll('[data-it7-desg]');
    if (!btns.length) return;
    adopt(saved);
    Array.prototype.forEach.call(btns, function (b) {
      var on = indexOfName(saved, b.getAttribute('data-it7-desg')) > -1;
      b.classList.toggle('on', on);
      var ic = b.querySelector('.ic');
      if (ic) ic.textContent = on ? '♥' : '♡';
      var t = b.querySelector('.t');
      if (t) {
        var lbl = on ? b.getAttribute('data-t-saved') : b.getAttribute('data-t-save');
        if (lbl) t.textContent = lbl;
      }
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var a = on ? b.getAttribute('data-t-alabel-on') : b.getAttribute('data-t-alabel');
      if (a) { b.setAttribute('aria-label', a); b.setAttribute('title', a); }
    });
  }

  /* Identify, in order of trust:
     1. logged-in customer — snippets/klaviyo-events.liquid already pushes
        ['identify', {$email …}] on EVERY page, so the SDK profile is set before we
        track. Re-identifying here (from a possibly stale local email) could clobber
        it, so when data-it7-known="1" we push the event only.
     2. guest whose email was captured earlier → localStorage it7wlemail.
     3. nothing → save locally, toggle the UI, and still track: Klaviyo attributes it
        to the anonymous cookie profile and merges it into the real profile the moment
        the shopper identifies, so the save is not lost. */
  function guestEmail() {
    var v = '';
    try { v = localStorage.getItem(EMAIL_KEY) || ''; } catch (e) { return ''; }
    if (!v) return '';
    if (v.charAt(0) === '"') { try { v = JSON.parse(v); } catch (e) {} }
    v = String(v).trim();
    return v.indexOf('@') > 0 ? v : '';
  }

  function track(designer, known) {
    try {
      if (!window._learnq) return;
      if (!known) {
        var em = guestEmail();
        if (em) window._learnq.push(['identify', { '$email': em }]);
      }
      window._learnq.push(['track', 'Saved Designer', {
        designer: designer,
        URL: location.origin + location.pathname
      }]);
    } catch (e) { /* analytics must never break the toggle */ }
  }

  /* detail.designers stays an array of NAMES — that is the shape this event has always
     had. The v2 entries ride along beside it as detail.entries. */
  function emit(name, saved, list) {
    try {
      document.dispatchEvent(new CustomEvent('it7:designer-saved', {
        detail: {
          designer: name,
          saved: saved,
          designers: list.map(function (e) { return e.n; }),
          entries: list
        }
      }));
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-it7-desg]') : null;
    if (!b) return;
    var name = (b.getAttribute('data-it7-desg') || '').trim();
    if (!name) return;
    var list = lsGet();
    var i = indexOfName(list, name);
    var saving = i < 0;
    if (saving) list.push({ n: name, h: (b.getAttribute('data-it7-handle') || '').trim() || null });
    else list.splice(i, 1);
    lsSet(list);
    paint();
    if (saving) track(name, b.getAttribute('data-it7-known') === '1');
    emit(name, saving, list);
  });

  /* cross-tab sync: another tab saved/unsaved the same designer */
  window.addEventListener('storage', function (e) { if (!e || !e.key || e.key === KEY) paint(); });

  migrate();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  window.addEventListener('pageshow', paint);   /* bfcache restore keeps the heart honest */

  /* Read API for pages that render saved designers rather than a heart — today the
     Saved Designers band on templates/page.swym.liquid. remove() is routed through
     here (rather than the band writing localStorage itself) so the hearts elsewhere on
     the page repaint and the same it7:designer-saved event fires. Unsaving never
     tracks: 'Saved Designer' is a save-only signal. */
  window.IT7DESG = {
    list: function () { return lsGet(); },
    has: function (name) { return indexOfName(lsGet(), name) > -1; },
    remove: function (name) {
      var list = lsGet();
      var i = indexOfName(list, name);
      if (i < 0) return false;
      list.splice(i, 1);
      lsSet(list);
      paint();
      emit(name, false, list);
      return true;
    }
  };
})();
